export const colors = {
  separator: {
    border: '#CCCCCC',
    divider: '#E5E5E5',
  },
  page: {
    surface: '#FFFFFF',
    background: '#F2F2F2',
    plateLight: '#F7F7F7',
    plateMedium: '#D9D9D9',
    plateDark: '#4D4D4D',
  },
  feature: {
    primary: '#000000',
    secondary: '#767676',
    placeholder: '#B2B2B2',
    onInteraction: '#FFFFFF',
  },
  brand: {
    primary: '#222222',
    secondary: '#F47624',
  },
  interaction: {
    main: '#005CEA',
    hover: '#3584FF',
    active: '#1049A1',
    disabled: '#D9D9D9',

    surfaceHover: '#E9F1FF',
    surfaceActive: '#C7DDFF',
    surfaceDisabled: '#F7F7F7',

    surfaceSuggestionHover: '#F4EBFF',
    surfaceSuggestionActive: '#E6D3FF',

    plateMediumHover: '#CECECE',
    plateMediumActive: '#CECECE',

    overlayHover: '#0048DC1F',

    destructive: '#E11D1D',
    destructiveHover: '#FF5E5E',
    destructiveActive: '#CC1F1F',

    suggestion: '#8C41ED',
    suggestionHover: '#A163EF',
    suggestionActive: '#782CDA',

    focus: 'rgba(0,72,220,0.345)',

    modified: '#FFEEB6',

    superuser: '#FF00E5',

    tooltip: '#3A3A3A',
  },
  status: {
    notApplicable: '#B2B2B2',
    notStarted: '#787878',
    onHold: '#E11D1D',
    inProgress: '#F59300',
    nearComplete: '#FFD600',
    complete: '#1DC502',
  },
  alert: {
    assistance: '#8C41ED',
    error: '#E11D1D',
    warning: '#F59300',
    success: '#1DC502',
    info: '#06D1DE',

    surfaceAssistance: '#F4EBFF',
    surfaceError: '#FFCACA',
    surfaceWarning: '#FFE2B7',
    surfaceSuccess: '#CFFFC8',
    surfaceInfo: '#DFFDFF',
  },
  tag: {
    ITAR: '#E11D1D',
  },
  overlay: {
    drawer: 'rgba(0,0,0,0.25)',
    modal: 'rgba(0,0,0,0.25)',
  },
  avatar: {
    magenta: '#A51A54',
    copper: '#C9500B',
    brass: '#B37702',
    green: '#246B41',
    teal: '#087980',
    blue: '#155CBB',
    purple: '#5E35B5',
    lead: '#4D4D4D',
  },
  gradients: {
    thumbnail: 'linear-gradient(150deg, #fff 0%, #cccccc 100%)',
  },
  geometry: {
    x: '#E95242',
    y: '#599773',
    z: '#3075D2',
  },
  featureReleaseStatus: {
    publicBeta: '#5037D5',
    privateBeta: '#DF2669',
  },
  // future color palette
  aluminum: {
    50: '#EDF1F2',
    100: '#DCE4E6',
    200: '#BAC6C8',
    300: '#A0AAAD',
    400: '#848D8F',
    500: '#6C7375',
    600: '#555A5C',
    700: '#414546',
    800: '#2B2F30',
    900: '#1A1C1C',
    950: '#0F1112',
  },
  blue: {
    50: '#EAF1FF',
    100: '#D0E0FF',
    200: '#A6C4FF',
    300: '#74A5FF',
    400: '#3286FF',
    500: '#1468E1',
    600: '#0055AE',
    700: '#004281',
    800: '#002F59',
    900: '#001A34',
  },
  teal: {
    50: '#EEF5F7',
    100: '#CCEBEE',
    200: '#96D7E0',
    300: '#5AC1D3',
    400: '#2AACC6',
    500: '#1093AB',
    600: '#188095',
    700: '#165D69',
    800: '#0F3C43',
    900: '#171F20',
  },
  coolant: {
    50: '#EEF6F3',
    100: '#CDEDDC',
    200: '#9DDCBF',
    300: '#58C698',
    400: '#32B385',
    500: '#199977',
    600: '#247A5B',
    700: '#1F6047',
    800: '#0F3D29',
    900: '#10271A',
  },
  green: {
    50: '#DBFBB5',
    100: '#B3F66B',
    200: '#8EDA52',
    300: '#6AC33B',
    400: '#43A827',
    500: '#068E0F',
    600: '#2A6F16',
    700: '#295314',
    800: '#20360E',
    900: '#131F07',
  },
  brass: {
    50: '#F8F3CC',
    100: '#F3E6A4',
    200: '#E9D163',
    300: '#E4B80C',
    400: '#CAA016',
    500: '#AC8807',
    600: '#846A15',
    700: '#584A13',
    800: '#423914',
    900: '#221F13',
  },
  copper: {
    50: '#FFF0E1',
    100: '#FFE3C7',
    200: '#F9B153',
    300: '#F88D00',
    400: '#E88502',
    500: '#C26700',
    600: '#935C00',
    700: '#6E4500',
    800: '#4C2E00',
    900: '#2C1A00',
  },
  red: {
    50: '#FEEDED',
    100: '#FCDBDB',
    200: '#FCA1A1',
    300: '#FB7474',
    400: '#F75656',
    500: '#E42323',
    600: '#B51A1A',
    700: '#8E1212',
    800: '#650909',
    900: '#3F0303',
  },
  magenta: {
    50: '#F9EEF0',
    100: '#F6DCE0',
    200: '#F1B1C0',
    300: '#EB7FA0',
    400: '#E76898',
    500: '#D73E84',
    600: '#AA3465',
    700: '#81284A',
    800: '#5B1B31',
    900: '#350E1A',
  },
  purple: {
    50: '#EEECFA',
    100: '#DED9F6',
    200: '#C1B3F0',
    300: '#A98BEB',
    400: '#975DE7',
    500: '#822CCD',
    600: '#6528A8',
    700: '#492083',
    800: '#311760',
    900: '#1B0D3F',
  },
  chartreuse: {
    50: '#F3F7CF',
    100: '#E7EDAE',
    200: '#C8D46E',
    300: '#AFBF3B',
    400: '#9FB125',
    500: '#859406',
    600: '#6B7524',
    700: '#4C531D',
    800: '#363920',
    900: '#1F2015',
  },
  rust: {
    50: '#FBECE7',
    100: '#F9DDD4',
    200: '#F89372',
    300: '#F67546',
    400: '#EB6935',
    500: '#DB551B',
    600: '#9E4020',
    700: '#742F1A',
    800: '#4C1D11',
    900: '#2D1009',
  },
} as const;
